module.exports = __webpack_public_path__ + "fonts/Aeonik-Regular.1528e21.woff2";